<template>
  <div style="margin-top: 50px">
    <mt-header title="录入工单列表">
      <div slot="right">
        <mt-button class="m-1" @click="addNegative"
          ><img slot="icon" src="@/assets/add.png" width="24" height="24" />
        </mt-button>
      </div>
    </mt-header>
    <!-- 查询工具栏 -->
    <div class="seach">
      <mt-search
        style="width: 100%; height: 50px"
        v-model="query.queryString"
        @keyup.enter.native="querySubmit"
      ></mt-search>
    </div>
    <!-- 记录列表-->
    <scroll-body
      style="margin-top: 10px"
      :minheight="200"
      :outheight="180"
      :isScroll="true"
      @resize="resize"
    >
      <template slot="content">
        <ul
          class="telitem infinite-list"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          :style="bodyStyle"
        >
          <li
            v-for="(item, index) in data.psts"
            :key="index"
            class="infinite-list-item"
          >
            <mt-cell
              :title="item.title"
              :label="
                Common.dateFormatter(item.postingTime, 'yyyy-MM-dd') +
                ' ' +
                item.pstSource.replace('红网', '') +
                ' ' +
                item.name +
                ' ' +
                item.timeIntervalString +
                ' ' +
                getStatusTitle(item)
              "
              is-link
              @click.native="editNegative(item)"
            />
          </li>
        </ul>
      </template>
    </scroll-body>
  </div>
</template>
  
<script>
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
  },
  created() {
    this.pstApi.setWindowTitle("舆情上报");
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        units: [], //单位数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        pstType: 1, //类别 1 负面舆情
        category: -10, //状态 -2 工单提交待审查，还未通过的。-10 表示所有负面工单
        queryString: "", //模糊字段
      },
      //分页查询参数
      xpagination: {
        totalCount: 1,
        totalPages: 1,
        pageNumber: 1,
        pageSize: 10,
      },
      loading: false,
      //
      mouseStatus: {
        current: 0,
        seen: false,
      },
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
    };
  },
  methods: {
    getStatusTitle(row) {
      //console.log(row)
      if (row.isSucces) {
        return this.appApi.getStatusTransferTitle(row.status);
      }
      return "待提交";
    },
    loadMore() {
      // 判断是否到了最大页数，已是最大页数则不继续加载数据
      if (this.xpagination.pageNumber >= this.xpagination.totalPages) return;
      this.xpagination.pageNumber++;

      this.loading = true;
      this.pstApi
        .getNegativeList(
          this.query.category,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize
        )
        .then((res) => {
          this.loading = false;
          let last = res.data;
          if (last == "") return;
          this.data.psts = this.data.psts.concat(last);
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          this.$toast("读取失败");
        });
    },
    //查询方法部分
    querySubmit() {
      this.getPstList();
    },
    getPstList() {
      this.pstApi
        .getNegativeList(
          this.query.category,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          // console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          this.$toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    addNegative() {
      this.$router.push({ name: "Negative" });
    },
    editNegative(pst) {
      //if (pst.status == -2) {
      this.$router.push({ name: "EditNegative", params: { id: pst.id } });
      //}
    },
    //删除
    deleteRow(pst) {
      if (pst.status < 0) {
        this.$confirm("确定要删除此条记录吗?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.pstApi
              .deleteNegative(pst.id)
              .then((res) => {
                this.$toast("删除成功");
                this.getPstList();
              })
              .catch((err) => {
                var message = err.response.data.Message;
                if (message == null) {
                  message = "删除失败";
                }
                this.$toast(message);
              });
          })
          .catch(() => {
            // row.status = row.status === 0 ? 1 : 0;
            // console.log("取消");
          });
      }
    },
    enter(index) {
      this.mouseStatus.current = index;
      this.mouseStatus.seen = true;
    },
    leave() {
      this.mouseStatus.current = null;
      this.mouseStatus.seen = true;
    },
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
    formReturn() {
      this.$router.back();
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>